/**
 * i18n Configuration
 * Internationalization setup for AgendaCRM
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { settingsStorage } from '../utils/settingsStorage';

// Translation resources
import es from './locales/es.json';
import en from './locales/en.json';

const resources = {
    es: { translation: es },
    en: { translation: en },
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: 'es', // Default language
        fallbackLng: 'es',

        interpolation: {
            escapeValue: false, // React already escapes
        },

        // Namespace configuration
        defaultNS: 'translation',

        // Debug mode in development
        debug: process.env.NODE_ENV === 'development',

        // Detect language from settingsStorage
        detection: {
            order: ['localStorage', 'navigator'],
            lookupLocalStorage: 'agendacrm_language',
            caches: ['localStorage'],
        },
    });

export default i18n;

// Helper hook for changing language
export const changeLanguage = (lang: 'es' | 'en') => {
    i18n.changeLanguage(lang);
    settingsStorage.setItem('LANGUAGE', lang);
};

// Get current language
export const getCurrentLanguage = () => i18n.language;
